import React, { Component } from "react";
import styles from './ComingSoon.styles';
import messages from './ComingSoon.messages';

export default class ComingSoon extends Component {
  render() {
    return (
      <div style={styles.container}>
        <h1>{messages.title}</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/guest/coming-soon/ComingSoon.js